;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require("moment");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _yup = require("yup");

var yup = _interopRequireWildcard(_yup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basicDetailsSchema = yup.object().shape({
  merchant_id: yup.string().required("Merchant is required"),
  service_name: yup.string().required("Service name is required"),
  desc: yup.string().required("Description is required"),
  selected_currency_id: yup.string().required("Currency is required"),
  service_type: yup.string().required().default("global"),
  status: yup.string().required().default("active")
});
var settlementConfigSchema = yup.object().shape({
  bank_account_id: yup.string().required(" Settlement Configuration: bank account is required"),
  settlement_type: yup.string().required("Settlement").default("automatic")
});
exports.default = {
  props: ["tiered_comms", "comm_type", "gateways", "all_allowed_gateways", "all_excluded_gateways", "current_currency", "all_currencies", "all_sms_templates", "all_html_templates", "selected_exempted_gateways", "selected_exempted_gateway_ids", "selected_commission_config", "selected_commission_configs_ids", "commission_setups", "all_merchants", "all_banks", "all_commissions", "cur_service", "action", "status"],
  data: function data() {
    var _ref;

    return _ref = {
      tiered_commissions: [{ min: "", max: "", value: "" }],
      commission_type: "",
      all_gateways: [],
      all_exempted_gateways: [],
      commission_config: "",
      all_commission_configs: [],
      selected_commissions: [],
      excluded_gateways: [],
      allowed_gateways: [],
      currency_list: [],
      sms_templates: [],
      merchants: [],
      bank_accounts: [],
      selected_currency: {},
      merchant: {},
      bank_account: {}
    }, (0, _defineProperty3.default)(_ref, "bank_accounts", []), (0, _defineProperty3.default)(_ref, "revShareAccount", {}), (0, _defineProperty3.default)(_ref, "revShares", []), (0, _defineProperty3.default)(_ref, "strRevShares", "[]"), (0, _defineProperty3.default)(_ref, "otherConfigs", []), (0, _defineProperty3.default)(_ref, "basicDetails", {
      merchant: {},
      merchant_id: "",
      selected_currency: {},
      selected_currency_id: "",
      service_name: "",
      desc: "",
      cost: "",
      cost_type: "fixed",
      service_type: "global",
      status: "active"
    }), (0, _defineProperty3.default)(_ref, "commissions", []), (0, _defineProperty3.default)(_ref, "paymentConfiguration", {
      partial: false,
      payment_code: "",
      api_notification: false,
      notification_url: "",
      receive_email: false,
      email: "",
      receive_sms: false,
      sms_recipient: "",
      selected_sms_template: {},
      selected_html_template: {},
      selected_sms_template_id: "",
      selected_html_template_id: "",
      direct_payment_to_paybill_disabled: false
    }), (0, _defineProperty3.default)(_ref, "settlementConfig", {
      bank_account: {},
      bank_account_id: "",
      settlement_type: "automatic",
      execution: ""
    }), (0, _defineProperty3.default)(_ref, "commission", {}), (0, _defineProperty3.default)(_ref, "commissionConfig", { commission_id: "", pesaflow_commission_exempted: false }), (0, _defineProperty3.default)(_ref, "revShare", {
      bank_account_id: "",
      account_number: null,
      type: "fixed",
      value: null,
      account_name: null,
      account_id: null,
      desc: "",
      index: null
    }), (0, _defineProperty3.default)(_ref, "otherConfigs", []), (0, _defineProperty3.default)(_ref, "error", {
      selected_currency: false,
      service_name: false,
      desc: false,
      cost: false,
      merchant: false,
      service_type: false,
      partial: false,
      payment_code: false,
      api_notification: false,
      notification_url: false,
      receive_email: false,
      email: false,
      receive_sms: false,
      sms_recipient: false,
      selected_sms_template: false,
      selected_html_template: false
    }), (0, _defineProperty3.default)(_ref, "service", {
      merchant: {},
      merchant_id: "",
      selected_currency: {},
      select_currency_id: "",
      service_name: "",
      desc: "",
      cost: "",
      cost_type: "",
      service_type: "",
      partial: false,
      payment_code: "",
      api_notification: "",
      notification_url: "",
      receive_email: "",
      email: "",
      receive_sms: "",
      sms_recipient: "",
      bank_account: {},
      bank_account_id: "",
      settlement_type: "automatic",
      execution: "day",
      commission: {},
      commission_id: "",
      otherConfigs: [],
      revShares: [],
      metadata: "{}",
      pesaflow_commission_exempted: false,
      status: "active",
      selected_sms_template: null,
      selected_html_template: null,
      selected_sms_template_id: "",
      selected_html_template_id: ""
    }), (0, _defineProperty3.default)(_ref, "extracted_allowed_gateways", []), (0, _defineProperty3.default)(_ref, "currentAction", ""), (0, _defineProperty3.default)(_ref, "status", {}), (0, _defineProperty3.default)(_ref, "settlementConfigErrors", {}), (0, _defineProperty3.default)(_ref, "basicDetailsErrors", {}), _ref;
  },
  mounted: function mounted() {
    var _this = this;

    if (this.tiered_comms) {
      this.tiered_commissions = JSON.parse(this.tiered_comms);
    }

    if (!this.all_allowed_gateways) {
      this.extracted_allowed_gateways = [];
    } else {
      this.extracted_allowed_gateways = JSON.parse(this.all_allowed_gateways);
    }

    this.commission_type = this.comm_type;
    if (this.all_merchants) {
      this.merchants = JSON.parse(this.all_merchants);
    }
    this.currency_list = JSON.parse(this.all_currencies);
    if (this.cur_service) {
      this.service = JSON.parse(this.cur_service);
      this.service.merchant = (0, _assign2.default)(this.service.merchant, {
        label: this.service.merchant.name
      });
      this.service.merchant_id = this.service.merchant.id || this.service.merchant_id;

      this.service.currency_id = this.service.selected_currency.id || this.service.selected_currency;

      this.current_currency = (0, _stringify2.default)(this.currency_list.find(function (x) {
        return parseInt(x.id) === parseInt(_this.service.selected_currency);
      }));
      if (this.current_currency) {
        this.selected_currency = JSON.parse(this.current_currency);
        this.service.selected_currency = this.selected_currency;
        this.allowed_gateways = this.extracted_allowed_gateways.filter(function (x) {
          return x.currency === _this.selected_currency.symbol;
        });
      }

      this.fetchBankAccounts();
      this.initializeOtherConfig(this.service.metadata);
      this.initializeSettlementConfig(this.service.bank_account);
      this.initializeBasicDetails(this.service);
      this.initializePaymentDetails(this.service);
      this.initializeCommConfig(this.service);
      this.service.metadata = (0, _stringify2.default)(this.service.metadata || {});
      this.revShares = this.service.rev_shares || [];
      this.service.merchant_id = this.service.merchant ? this.service.merchant.id || this.service.merchant_id : "";

      this.service.bank_account_id = this.service.bank_account ? this.service.bank_account.id || this.service.bank_account_id : "";
      this.service.commission_id = this.service.commission ? this.service.commission.id : "";
      this.merchant = this.merchants.find(function (m) {
        return parseInt(m.value) === parseInt(_this.service.merchant_id);
      });
      this.service.merchant.label = this.merchant ? this.merchant.label : this.service.merchant.name;
      this.strRevShares = (0, _stringify2.default)(this.service.rev_shares || []);
      this.status = this.service.status;
    }

    this.all_gateways = this.gateways;
    this.all_exempted_gateways = this.selected_exempted_gateways;
    this.all_commission_configs = this.commission_setups;
    this.allowed_gateways = this.extracted_allowed_gateways;

    if (this.all_sms_templates) {
      this.sms_templates = JSON.parse(this.all_sms_templates);
    }

    if (this.all_html_templates) {
      this.html_templates = JSON.parse(this.all_html_templates);
    }

    if (this.all_excluded_gateways) {
      this.excluded_gateways = JSON.parse(this.all_excluded_gateways);
    }

    if (this.selected_commission_config) {
      this.commission_config = this.selected_commission_config;
    } else if (this.commission_type == "tiered_percentage" || this.commission_type == "tiered_fixed" || this.commission_type == "fixed" || this.commission_type == "percentage") {
      this.commission_config = "custom";
    } else {}

    if (this.selected_exempted_gateway_ids) {
      var ids_arr = this.selected_exempted_gateway_ids.split(",").map(function (x) {
        return parseInt(x);
      });
      this.all_exempted_gateways = this.gateways.filter(function (gateway) {
        return ids_arr.includes(gateway.id);
      });
    }

    if (this.selected_commission_configs_ids) {
      this.selected_commissions = this.all_commission_configs.filter(function (x) {
        return _this.selected_commission_configs_ids.includes(x.id);
      });
    }
    if (this.action) {
      this.currentAction = this.action;
    }

    $("#settlementConfigModal").on("shown.bs.modal", function () {
      _this.fetchBankAccounts();
    });

    basicDetailsSchema.validate(this.basicDetails, { abortEarly: false }).then(function (response) {
      _this.basicDetailsErrors = {};
    }).catch(function (err) {
      err.inner.forEach(function (item) {
        _this.basicDetailsErrors = (0, _defineProperty3.default)({}, item.path, item.message);
      });
    });

    settlementConfigSchema.validate(this.settlementConfig, { abortEarly: false }).then(function (response) {
      _this.settlementConfigErrors = {};
    }).catch(function (err) {
      err.inner.forEach(function (item) {
        _this.settlementConfigErrors = (0, _defineProperty3.default)({}, item.path, item.message);
      });
    });
  },

  computed: {
    basicDetailsErrorsExists: function basicDetailsErrorsExists() {
      if ((0, _keys2.default)(this.basicDetailsErrors).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    settlementConfigErrorsExists: function settlementConfigErrorsExists() {
      if ((0, _keys2.default)(this.settlementConfigErrors).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    errorHolders: function errorHolders() {
      return this.settlementConfigErrorsExists || this.basicDetailsErrorsExists;
    },
    tiered_comm: function tiered_comm() {
      return (0, _stringify2.default)(this.tiered_commissions);
    },
    all_exempted_gateway_ids: function all_exempted_gateway_ids() {
      return this.all_exempted_gateways.map(function (x) {
        return x.id;
      });
    },
    selected_commission_ids: function selected_commission_ids() {
      return this.selected_commissions.map(function (x) {
        return x.id;
      });
    },
    payment_gateway_ids: function payment_gateway_ids() {
      return this.excluded_gateways.map(function (x) {
        return x.id;
      });
    },
    select_currency: function select_currency() {
      return this.basic_details.selected_currency;
    },
    selected_currency_id: function selected_currency_id() {
      return this.basic_details.selected_currency ? this.basic_details.selected_currency.id : null;
    },
    merchant_id: function merchant_id() {
      return this.basic_details.merchant ? this.basic_details.merchant.id : null;
    }
  },
  methods: {
    add_commission: function add_commission() {
      this.tiered_commissions.push({ min: "", max: "", value: "" });
    },
    remove_commission: function remove_commission(index) {
      this.tiered_commissions.splice(index, 1);
    },
    setExcludedGateways: function setExcludedGateways(v) {
      this.all_exempted_gateways = v;
    },
    setConfigType: function setConfigType(v) {
      this.commission_config = v.target.value;
      if (this.commission_config == "preconfigured" || this.commission_config == "exempt") {
        this.tiered_commissions = [];
        this.commission_type = "";
      }
    },
    setCommConfigs: function setCommConfigs(v) {
      this.selected_commissions = v;
    },
    currencyChange: function currencyChange(v) {
      if (v) {
        var comms = JSON.parse(this.all_commissions);
        this.commissions = comms.filter(function (x) {
          if (x.currency_id == v.id) {
            return (0, _assign2.default)(x, { label: x.name });
          }
          return x.currency_id == v.id;
        });
      }
    },
    changeTemplate: function changeTemplate(v) {
      this.paymentConfiguration.selected_sms_template = v;
      this.paymentConfiguration.selected_sms_template_id = v.id;
    },
    handleTemplateChange: function handleTemplateChange(value) {
      if (!value) {
        this.clearHtmlTemplate();
      } else {
        this.changeHtmlTemplate(value);
      }
    },
    changeHtmlTemplate: function changeHtmlTemplate(v) {
      this.paymentConfiguration.selected_html_template = v;
      this.paymentConfiguration.selected_html_template_id = v.id;
    },
    clearHtmlTemplate: function clearHtmlTemplate() {
      this.paymentConfiguration.selected_html_template = {};
      this.paymentConfiguration.selected_html_template_id = "";
    },
    merchantChange: function merchantChange(v) {
      this.basicDetails.merchant_id = v.value;
      this.basicDetails.merchant = v;
    },
    bankAccountChange: function bankAccountChange(v) {
      this.settlementConfig.bank_account_id = v.id;
      this.settlementConfig.bank_account = v;
    },
    initializeOtherConfig: function initializeOtherConfig(object) {
      if (object) {
        var data = [];
        (0, _keys2.default)(object).forEach(function (key) {
          var value = object[key];
          data.push({ key: key, value: value });
        });
        this.otherConfigs = data;
        this.service.metadata = (0, _stringify2.default)(this.service.metadata);
      } else {
        return {};
      }
    },
    initializeBasicDetails: function initializeBasicDetails(object) {
      this.currency_list = JSON.parse(this.all_currencies);
      this.basicDetails = {
        merchant_id: object.merchant_id,
        merchant: {
          id: object.merchant.id || this.merchant.value,
          label: object.merchant.name || this.merchant.label,
          value: object.merchant.id || this.merchant.value
        },
        selected_currency: {
          symbol: object.selected_currency.symbol,
          label: object.selected_currency.name || object.selected_currency.label,
          id: object.selected_currency.id
        },
        selected_currency_id: object.selected_currency ? object.selected_currency.id : "",
        service_name: object.service_name,
        desc: object.desc,
        cost: object.cost,
        cost_type: object.cost_type,
        service_type: object.service_type,
        status: object.status
      };
    },
    initializePaymentDetails: function initializePaymentDetails(object) {
      this.paymentConfiguration = {
        partial: object.partial,
        payment_code: object.payment_code,
        api_notification: object.notification_url ? true : false,
        notification_url: object.notification_url,
        email: object.email,
        receive_email: object.email ? true : false,
        sms_recipient: object.sms_recipient,
        receive_sms: object.sms_recipient ? true : false,
        selected_sms_template: object.selected_sms_template ? {
          id: object.selected_sms_template.id,
          label: object.selected_sms_template.name
        } : {},
        selected_sms_template_id: object.selected_sms_template ? object.selected_sms_template.id : null,
        selected_html_template: object.selected_html_template ? {
          id: object.selected_html_template.id,
          label: object.selected_html_template.name
        } : {},
        selected_html_template_id: object.selected_html_template ? object.selected_html_template.id : null,
        direct_payment_to_paybill_disabled: object.direct_payment_to_paybill_disabled
      };
    },
    initializeCommConfig: function initializeCommConfig(object) {
      if (object.commission) {
        this.commission = (0, _assign2.default)(object.commission, {
          label: object.commission.name
        });
        this.commissionConfig = {
          commission_id: object.commission ? object.commission.id : "",
          commission: object.commission,
          pesaflow_commission_exempted: object.pesaflow_commission_exempted
        };
      }
    },
    initializeSettlementConfig: function initializeSettlementConfig(object) {
      if (object) {
        var id = this.get_bank_account_id(object);
        var data = {
          bank_account: {
            id: id,
            label: this.get_bank_account_name(object),
            number: this.get_bank_account_number(object)
          },
          bank_account_id: id,
          settlement_type: object.settlement_type,
          execution: "day"
        };
        this.settlementConfig = data;
      } else {
        return {};
      }
    },
    get_bank_account_id: function get_bank_account_id(bank_account) {
      if (bank_account) return bank_account.id;
      return "";
    },
    get_bank_account_name: function get_bank_account_name(bank_account) {
      if (bank_account) return bank_account.name;
      return "";
    },
    get_bank_account_number: function get_bank_account_number(bank_account) {
      if (bank_account) return bank_account.account_number;
      return "";
    },

    fetchBankAccounts: function fetchBankAccounts() {
      var _this2 = this;

      _axios2.default.get("/bank-accounts/filtered", {
        params: {
          type: "utility",
          currency: this.service.selected_currency.symbol,
          owner_type: "merchant",
          merchant_id: this.service.merchant_id
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        var listOfBankAccounts = data;
        _this2.bank_accounts = listOfBankAccounts.map(function (account) {
          return {
            id: account.id,
            label: account.account_number + " - " + account.name,
            number: account.account_number,
            name: account.name
          };
        });
      }).catch(function (error) {});
    },
    fetchBankAccount: function fetchBankAccount(account_number) {
      var _this3 = this;

      _axios2.default.get("/accounts-get", {
        params: {
          account_id: account_number,
          currency: this.service.selected_currency.symbol
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this3.revShare = data;
      }).catch(function (error) {});
    },
    exludeGateway: function exludeGateway(v) {
      this.excluded_gateways = v;
    },
    captureData: function captureData() {
      var _this4 = this;

      var required = ["service_name", "desc", "merchant_id", "selected_currency_id", "service_type"];
      this.basicDetails.selected_currency_id = this.basicDetails.selected_currency.id;
      this.basicDetails.merchant_id = this.merchant.value || this.merchant.id;
      if (this.basicDetails.cost_type == "fixed") required.push("cost");
      var value = this.validateForm(this.basicDetails, required);
      if (value.pass) {
        this.service = (0, _assign2.default)(this.service, this.basicDetails);
        document.getElementById("serviceDetailsBtn").click();
        this.fetchBankAccounts();
      }

      basicDetailsSchema.validate(this.basicDetails, { abortEarly: false }).then(function (response) {
        _this4.basicDetailsErrors = {};
      }).catch(function (err) {
        err.inner.forEach(function (item) {
          _this4.basicDetailsErrors = (0, _defineProperty3.default)({}, item.path, item.message);
        });
      });
    },
    capturePaymentDataData: function capturePaymentDataData() {
      try {
        var required = [];
        if (this.paymentConfiguration.api_notification) required.push("notification_url");
        if (this.paymentConfiguration.receive_email) required.push("email");
        if (this.paymentConfiguration.receive_sms) required.push("sms_recipient");
        var value = this.validateForm(this.paymentConfiguration, required);

        if (value.pass) {
          if (this.paymentConfiguration.api_notification === false) this.paymentConfiguration.notification_url = "";
          if (this.paymentConfiguration.receive_email === false) this.paymentConfiguration.email = "";
          if (this.paymentConfiguration.receive_sms === false) this.paymentConfiguration.sms_recipient = "";
          this.service = (0, _assign2.default)(this.service, this.paymentConfiguration);
          document.getElementById("paymentConfigBtn").click();
        }
      } catch (error) {}
    },
    captureSettlementData: function captureSettlementData() {
      var _this5 = this;

      var required = ["bank_account_id", "settlement_type"];
      if (this.settlementConfig.settlement_type == "automatic") required.push("execution");
      var value = this.validateForm(this.settlementConfig, required);
      if (value.pass) {
        this.service = (0, _assign2.default)(this.service, this.settlementConfig);
        document.getElementById("settlementConfigBtn").click();
      }

      settlementConfigSchema.validate(this.settlementConfig, { abortEarly: false }).then(function (response) {
        _this5.settlementConfigErrors = {};
      }).catch(function (err) {
        err.inner.forEach(function (item) {
          _this5.settlementConfigErrors = (0, _defineProperty3.default)({}, item.path, item.message);
        });
      });
    },
    captureRevShares: function captureRevShares() {
      var value = this.validateForm(this.revShare, ["account_name", "account_number", "type", "value"]);

      if (value.pass) {
        var shares = this.revShares.slice();
        this.revShare.desc = this.revShare.account_name + " " + this.revShare.account_number;
        var share = (0, _assign2.default)({}, this.revShare);
        delete share.index;
        if (this.revShare.index !== null && this.revShare.index !== undefined) {
          shares.splice(this.revShare.index, 1, share);
        } else {
          shares.push(share);
        }
        this.revShare = {
          account_name: "",
          account_number: "",
          desc: "",
          type: "",
          value: "",
          index: null
        };
        this.service.rev_shares = shares;
        this.revShares = shares;
        this.strRevShares = (0, _stringify2.default)(shares);
        this.service.strRevShares = (0, _stringify2.default)(shares);
        this.revShareAccount = {};
        document.getElementById("revSharesBtn").click();
      }
    },
    captureComms: function captureComms() {
      if (this.commissionConfig.pesaflow_commission_exempted == true) {
        this.commissionConfig.commission_id = null;
      } else {
        this.commissionConfig.commission_id = this.commission.id;
      }
      this.commissionConfig.pesaflow_commission_exempted = this.service.pesaflow_commission_exempted;

      if (this.commissionConfig.pesaflow_commission_exempted == "true") {
        this.service.commission_id = null;
        this.service.commission = {};
      } else {
        this.service.commission_id = this.commissionConfig.commission_id;
        this.service.pesaflow_commission_exempted = false;
        this.service.commission = this.commission;
      }
      document.getElementById("commsBtn").click();
    },
    captureOtherConfig: function captureOtherConfig() {
      var value = { pass: true };
      var data = {};
      this.otherConfigs.forEach(function (i) {
        if (!!!i.key || !!!value) {
          value.pass = false;
        } else {
          data = (0, _assign2.default)(data, (0, _defineProperty3.default)({}, i.key, i.value));
        }
      });
      this.service.metadata = (0, _stringify2.default)(data);
      if (value.pass) {
        this.service.otherConfigs = this.otherConfigs;
        document.getElementById("otherConfigBtn").click();
      }
    },

    validateForm: function validateForm(data, rules) {
      var _this6 = this;

      var errorText = false;
      rules.forEach(function (r) {
        if (!!!data[r]) {
          errorText = true;
          _this6.error[r] = "Required";
        }
      });

      if (errorText) return { pass: false };

      return { pass: true };
    },
    appendConfig: function appendConfig() {
      var data = this.otherConfigs;
      data.push({ key: "", value: "" });
      this.otherConfigs = data;
    },
    dropConfigItem: function dropConfigItem(index) {
      var data = this.otherConfigs;
      data.splice(index, 1);
      this.otherConfigs = data;
    },
    dropAllConfigs: function dropAllConfigs() {
      this.otherConfigs = [];
    },
    dropRevItem: function dropRevItem(index) {
      var data = this.revShares.slice();
      data.splice(index, 1);
      this.service.rev_shares = data;
      this.revShares = data;
      this.strRevShares = (0, _stringify2.default)(data);
      this.service.strRevShares = (0, _stringify2.default)(data);
      this.revShare = {
        account_name: "",
        account_number: "",
        desc: "",
        type: "",
        value: "",
        index: null
      };
      this.revShareAccount = {};
    },
    editRevItem: function editRevItem(index) {
      var item = this.service.rev_shares[index];
      this.revShare = (0, _assign2.default)({}, item, { index: index });
      document.getElementById("revSharesBtn").click();
    }
  },
  watch: {
    errorHolders: function errorHolders(newValue, oldValue) {
      var submitBtn = document.getElementById('serviceSubmit');
      if (newValue) {
        submitBtn.disabled = true;
      } else {
        submitBtn.disabled = false;
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9adc5b30", __vue__options__)
  } else {
    hotAPI.reload("data-v-9adc5b30", __vue__options__)
  }
})()}